/**
 * Project: Aniatek
 * Author: Carlos A. Loaiza | Connect & Launch
 * Tel: +52 (667) 247 - 6316
 * Intellectual Property: All rights reserved (c) 2026
 */
 
 <template>
  <ModalBase v-show="mostrarModalTabla">
    <section class="contenedorPrincipal">
      <section>
        <section class="contenedorTituloNombre">
          <div class="titulo">
            {{ tituloHeader }} <span class="tituloNombre">{{ ferreteriaLocal ? ferreteriaLocal.Nombre : ''
            }}</span>
          </div>
          <section class="botonesTitulo">
            <Button class="btn-editar-tabla" @click="agregarNuevoInsumo" title="Agregar nuevo artículo">
              <i class="fa-solid fa-plus"></i>
            </Button>
            <Button class="btn-editar" @click="toggleEdicion" title="Activar/Desactivar edición de precios">
              <i class="fa-solid fa-pen-to-square"></i>
            </Button>
            <Button class="btn-atras" @click="cancelar" title="Cerrar">
              <i class="fa-solid fa-xmark"></i>
            </Button>
          </section>
        </section>
        <div class="separador"></div>
      </section>

      <section class="SeccionInfoGeneral" v-if="ferreteriaLocal">
        <div class="separacion">
          ID Ferretería:
          <span class="fuenteSep">{{ ferreteriaLocal.id }}</span>
        </div>
        <div class="separacion">
          Teléfono:
          <span class="fuenteSep">{{ ferreteriaLocal.Telefono }}</span>
        </div>
        <div class="separacion">
          Domicilio:
          <span class="fuenteSep">{{ ferreteriaLocal.Domicilio }}</span>
        </div>
        <div class="separacion">
          Última Actualización:
          <span class="fuenteSep">{{ formatearFecha(ferreteriaLocal.Fecha_Actualizacion) }}</span>
        </div>
      </section>

      <section>
        <section class="tablaPrincipal">
          <table class="default">
            <thead>
              <tr class="cabecera">
                <th>ID Insumo</th>
                <th>Nombre Producto</th>
                <th>Unidad de Medida</th>
                <th>Precio Unitario</th>
                <th>Actualizado Por</th>
              </tr>
            </thead>
            <tbody class="tbody">
              <template v-if="ferreteriaLocal && ferreteriaLocal.Insumos.length">
                <tr v-for="(insumo, index) in ferreteriaLocal.Insumos" :key="insumo.__temp_key || index">

                  <td :class="{ 'fila-nueva-activa': insumo.__es_nuevo }">
                    <template v-if="editando || insumo.__es_nuevo">
                      <input class="inputEditarTabla" v-model="insumo.Id_Insumo" :ref="'input_' + index + '_0'"
                        @keyup.enter.prevent="navegarYGuardarArticulo(insumo, index, 0, $event)" />
                    </template>
                    <template v-else>
                      {{ insumo.Id_Insumo || 'No disponible' }}
                    </template>
                  </td>

                  <td>
                    <template v-if="editando || insumo.__es_nuevo">
                      <input class="inputEditarTabla" v-model="insumo.Nombre_Producto"
                        :ref="insumo.__es_nuevo ? 'nuevoArticuloInput' : 'input_' + index + '_1'"
                        @keyup.enter.prevent="navegarYGuardarArticulo(insumo, index, 1, $event)" />
                    </template>
                    <template v-else>
                      {{ insumo.Nombre_Producto || 'No disponible' }}
                    </template>
                  </td>

                  <td>
                    <template v-if="editando || insumo.__es_nuevo">
                      <input class="inputEditarTabla" v-model="insumo.Unidad_Medida" :ref="'input_' + index + '_2'"
                        @keyup.enter.prevent="navegarYGuardarArticulo(insumo, index, 2, $event)" />
                    </template>
                    <template v-else>
                      {{ insumo.Unidad_Medida || 'No disponible' }}
                    </template>
                  </td>

                  <td>
                    <template v-if="editando || insumo.__es_nuevo">
                      <input class="inputEditarTabla" v-model="insumo.Precio_Unitario" type="number"
                        :ref="'input_' + index + '_3'"
                        @keyup.enter.prevent="navegarYGuardarArticulo(insumo, index, 3, $event)" />
                    </template>
                    <template v-else>
                      $ {{ formatearNumero(insumo.Precio_Unitario) || 'No disponible' }}
                    </template>
                  </td>

                  <td>
                    <template v-if="editando || insumo.__es_nuevo">
                      <input class="inputEditarTabla" v-model="insumo.Actualizado_Por" :ref="'input_' + index + '_4'"
                        @keyup.enter.prevent="navegarYGuardarArticulo(insumo, index, 4, $event)" />
                    </template>
                    <template v-else>
                      {{ insumo.Actualizado_Por || '-' }}
                    </template>
                  </td>
                </tr>
              </template>
              <template v-else>
                <tr>
                  <td colspan="5">No hay insumos cargados para esta ferretería.</td>
                </tr>
              </template>
            </tbody>
            <tfoot>
              <tr class="totales">
                <td colspan="3"><strong>Total de Insumos:</strong></td>
                <td><strong>{{ ferreteriaLocal.Insumos.length }}</strong></td>
                <td></td>
              </tr>
            </tfoot>
          </table>
        </section>
      </section>

      <section class="contenedorBotones">
        <Button class="btn-guardar" @click="guardarCambios"
          v-if="editando || ferreteriaLocal.Insumos.some(i => i.__es_nuevo)" title="Guardar cambios">
          <i class="fa-solid fa-floppy-disk"></i> Guardar
        </Button>
      </section>
    </section>
  </ModalBase>
</template>

<script>
import Button from "../Forms/Button.vue";
import ModalBase from "../Modales/ModalBase.vue";
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';


dayjs.extend(customParseFormat);

export default {
  components: {
    Button,
    ModalBase,
  },
  props: {
    ferreteria: {
      type: Object,
      required: true
    },
    tituloHeader: {
      type: String,
      default: "Detalle de precios de",
    },
    newStyle: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      data: [],
      ferreteriaLocal: {
        Nombre: '',
        id: '',
        Telefono: '',
        Domicilio: '',
        Fecha_Actualizacion: '',
        Insumos: []
      },
      mostrarModalTabla: true,
      editando: false,
      guardandoNuevoArticulo: false,
    };
  },
  computed: {
    totalInsumos() {
      return this.ferreteriaLocal && this.ferreteriaLocal.Insumos ? this.ferreteriaLocal.Insumos.length : 0;
    },
  },
  watch: {
    ferreteria: {
      immediate: true,
      handler(nuevoValor) {
        if (nuevoValor && nuevoValor.id) {
          this.inicializarDatosFerreteria(nuevoValor);
        } else {
          this.ferreteriaLocal = null;
        }
      }
    },
    'ferreteriaLocal.Insumos': function () {
      this.$nextTick(() => {
        const nuevoInput = this.$refs.nuevoArticuloInput;
        if (nuevoInput && nuevoInput.length > 0) {
          nuevoInput[nuevoInput.length - 1].focus();
        }
      });
    }
  },

  mounted() {
    this.data = [
      { Id_Ferreteria: 1, Nombre: 'Ferretería El Tornillo Feliz', id: 'FC001', Telefono: '667-123-4567', Domicilio: 'Av. Álvaro Obregón 2345, Col. Centro', Fecha_Actualizacion: '2024-10-15', Id_Insumo: 'TORN01', Nombre_Producto: 'Tornillo de 1/4"', Unidad_Medida: 'Kg', Precio_Unitario: 85.50, Actualizado_Por: 'Admin1' },
      { Id_Ferreteria: 1, Nombre: 'Ferretería El Tornillo Feliz', id: 'FC001', Telefono: '667-123-4567', Domicilio: 'Av. Álvaro Obregón 2345, Col. Centro', Fecha_Actualizacion: '2024-10-15', Id_Insumo: 'VARILLA05', Nombre_Producto: 'Varilla Corrugada 1/2"', Unidad_Medida: 'Pza', Precio_Unitario: 250.00, Actualizado_Por: 'Admin1' },
      { Id_Ferreteria: 2, Nombre: 'Ferretería La Nueva Era', id: 'FN002', Telefono: '669-555-8899', Domicilio: 'Av. del Mar 1020, Zona Dorada', Fecha_Actualizacion: '2024-10-10', Id_Insumo: 'CLAV003', Nombre_Producto: 'Clavos de 2"', Unidad_Medida: 'Kg', Precio_Unitario: 55.00, Actualizado_Por: 'User9' },
    ];

    if (this.ferreteria && this.ferreteria.id) {
      this.inicializarDatosFerreteria(this.ferreteria);
    }
  },
  emits: ["cancelar"],
  methods: {
    toggleEdicion() {
      const hayTemporal = this.ferreteriaLocal.Insumos.some(i => i.__es_nuevo);

      if (!this.editando && hayTemporal) {
        alert('Debe guardar o descartar el nuevo artículo antes de salir del modo edición.');
        return;
      }
      this.editando = !this.editando;
    },

    inicializarDatosFerreteria(ferreteriaBase) {
      this.ferreteriaLocal = {
        Nombre: ferreteriaBase.nombre || 'No disponible',
        id: ferreteriaBase.id,
        Telefono: ferreteriaBase.telefono || 'No disponible',
        Domicilio: ferreteriaBase.domicilio || 'No disponible',
        Fecha_Actualizacion: dayjs().format('YYYY-MM-DD'),
        Insumos: []
      };
      this.obtenerInsumos(ferreteriaBase.id);
    },

    obtenerInsumos(idFerreteria) {
      const insumosFerreteria = this.data.filter(item => item.Id_Ferreteria.toString() === idFerreteria.toString());

      if (insumosFerreteria.length > 0) {
        this.ferreteriaLocal.Insumos = insumosFerreteria.map(item => ({
          ...item,
          __es_nuevo: false,
          __temp_key: item.Id_Insumo
        }));
      } else {
        this.ferreteriaLocal.Insumos = [];
      }
      this.mostrarModalTabla = true;
    },

    agregarNuevoInsumo() {
      this.editando = false;

      const existeTemp = this.ferreteriaLocal.Insumos.some(i => i.__es_nuevo);
      if (existeTemp) {
        alert('Por favor, complete o descarte el artículo nuevo antes de agregar otro.');
        return;
      }

      const nuevoInsumo = {
        Id_Insumo: '',
        Nombre_Producto: '',
        Unidad_Medida: '',
        Precio_Unitario: 0,
        Actualizado_Por: '',
        __es_nuevo: true,
        __temp_key: Date.now()
      };
      this.ferreteriaLocal.Insumos.push(nuevoInsumo);
    },

    guardarNuevoArticulo(insumo) {
      if (!insumo.__es_nuevo || !insumo.Nombre_Producto.trim()) {
        return;
      }

      this.guardandoNuevoArticulo = true;

      console.log(`Guardando nuevo artículo instantáneamente: ${insumo.Nombre_Producto}`);
      insumo.Id_Insumo = insumo.Id_Insumo || 'ARTICULO_' + Math.floor(Math.random() * 1000);
      insumo.__es_nuevo = false;

      this.guardandoNuevoArticulo = false;
    },

    cancelar() {
      this.ferreteriaLocal.Insumos = this.ferreteriaLocal.Insumos.filter(i => !i.__es_nuevo);

      this.mostrarModalTabla = false;
      this.$emit("cancelar");
    },
    formatearNumero(valor) {
      if (!valor && valor !== 0) return '0.00';
      return Number(valor).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    formatearFecha(fecha) {
      if (!fecha || fecha === 'No disponible') return 'No disponible';
      return dayjs(fecha).format('DD/MM/YYYY');
    },

    exportarExcel() {
      console.log("Simulando exportación a Excel...");
    },

    guardarCambios() {
      console.log('Guardando cambios para ferretería instantáneamente:', this.ferreteriaLocal);

      this.ferreteriaLocal.Insumos.forEach(insumo => {
        if (insumo.__es_nuevo) {
          insumo.Id_Insumo = insumo.Id_Insumo || 'ARTICULO_' + Math.floor(Math.random() * 1000);
          insumo.__es_nuevo = false;
        }
      });

      console.log('Simulación de guardado exitosa.');
      this.editando = false;
    },
  }
};
</script>

<style scoped>
.titulo {
  padding: 30px 0px 0px 0px;
  font-size: 30px;
}

.tituloNombre {
  font-style: italic;
  font-size: 27px;
  color: #29b9f6;
  font-weight: 600;
}

.botonesTitulo {
  padding-top: 30px;
  display: flex;
  gap: 10px;
}

.separador {
  border-top: 3px solid #2a428c;
  height: 2px;
  max-width: 100%;
  padding: 0;
  margin-top: 5px;
  margin: 5px 0px 20px;
}

.SeccionInfoGeneral {
  padding-bottom: 20px;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: flex-start;
}

.contenido-modal {
  width: 1000px !important;
}

.separacion {
  padding: 2.5px 0px;
  font-size: 17px;
  font-weight: bold;
  min-width: 250px;
}

.fuenteSep {
  font-size: 15px;
  font-weight: normal;
}

.contenedorPrincipal {
  margin: 0px 30px;
}

.contenedorTituloNombre {
  display: flex;
  justify-content: space-between;
}

.inputEditar {
  width: 200px;
  height: 32px;
  border: 0px solid #000000;
  box-shadow: 0px 3px 6px #00000029;
  outline: none;
  color: #000000;
  padding: 0px 7px;
  border-radius: 10px;
  margin: 0px 10px;
}

.contenedorBotones {
  display: flex;
  justify-content: center;
  max-width: 80%;
  margin: auto;
  padding: 30px 0px 20px;
}

.totales {
  background-color: #f1f1f1;
  font-weight: bold;
}

.cabecera {
  background: black;
  color: white;
}

.tablaPrincipal {
  width: 100%;
  overflow-x: auto;
}

.default {
  border-collapse: collapse;
  border-radius: 10px;
  width: 100%;
  box-shadow: 0px 3px 6px #00000029;
}

.default th {
  background-color: black;
  color: #fff;
  font-size: 16px;
  letter-spacing: 1px;
}

.default td,
.default th {
  border: none;
  padding: 15px 12px;
  text-align: center;
}

.tbody {
  font-size: 14.5px;
}

.default tr:nth-child(even) {
  background-color: #f8f8f8;
}

.inputEditarTabla {
  width: 120px;
  height: 32px;
  border: 0px solid #000000;
  box-shadow: 0px 3px 6px #00000029;
  outline: none;
  color: #000000;
  padding: 0px 7px;
  border-radius: 10px;
  margin: 0px;
  text-align: center;
}

@media (max-width: 810px) {
  .titulo {
    font-size: 25px
  }

  .tituloNombre {
    font-size: 24px
  }

  .SeccionInfoGeneral {
    flex-direction: column;
    gap: 10px;
  }

  .separacion {
    font-size: 15px;
    min-width: 100%;
  }

  .fuenteSep {
    font-size: 13px
  }

  .default td {
    font-size: 12px;
    letter-spacing: 0px;
    padding: 10px 5px;
  }

  .default th {
    padding: 10px 5px;
    font-size: 13px;
    letter-spacing: 0px;
  }

  .tbody {
    font-size: 10px;
  }

  .inputEditarTabla {
    width: 70px;
    height: 30px;
    border: 0.5px solid #000000;
    box-shadow: 0px 3px 6px #00000029;
    text-align: center;
  }

  .inputEditar {
    width: 150px;
    height: 30px;
    border: 0.5px solid #000000;
    margin: 0px 3px;
  }

  .botonesTitulo {
    display: flex;
    gap: 5px;
  }

  .btn-editar,
  .btn-descargar-excel,
  .btn-atras,
  .btn-agregar {
    font-size: 13px;
    width: 30px;
    height: 30px;
  }
}
</style>